import React from "react";
import "../css/about.scss";

function About() {
  return (
    <div className="about">
      <div className="about-container">
        <div className="about-content">
          <h1 className="about-title">About Sacuddin</h1>

          <div className="about-text">
            <p>
              Sacuddin is a contemporary jewelry brand founded with a vision to
              create timeless, elegant pieces that celebrate the beauty of
              everyday moments.
            </p>
            <p>
              Our collection features meticulously crafted jewelry designed to
              be worn and cherished for years to come. Each piece is
              thoughtfully created with attention to detail, quality materials,
              and exquisite craftsmanship.
            </p>
            <p>
              We believe that jewelry should be an expression of personal style
              and individuality. Whether you're looking for the perfect everyday
              piece or a special statement accessory, Sacuddin offers a range of
              designs to suit every occasion.
            </p>
            <p>
              Committed to quality and sustainability, we work with skilled
              artisans who share our passion for creating beautiful, lasting
              jewelry. Every piece in our collection reflects our dedication to
              excellence and our desire to bring joy to our customers.
            </p>
            <p>
              Thank you for choosing Sacuddin. We are honored to be part of your
              journey.
            </p>
          </div>

          <div className="about-values">
            <h2 className="values-title">Our Values</h2>
            <div className="values-grid">
              <div className="value-item">
                <h3 className="value-title">Quality</h3>
                <p className="value-description">
                  We are committed to using only the finest materials and
                  employing exceptional craftsmanship in every piece we create.
                </p>
              </div>
              <div className="value-item">
                <h3 className="value-title">Sustainability</h3>
                <p className="value-description">
                  We prioritize ethical sourcing and responsible production
                  practices to minimize our environmental impact.
                </p>
              </div>
              <div className="value-item">
                <h3 className="value-title">Customer Experience</h3>
                <p className="value-description">
                  Your satisfaction is our priority. We strive to provide
                  exceptional service and create lasting relationships with our
                  customers.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
